import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import IconButton from '../../common/icon-button/icon-button';
import DashboardFilters from '../dashboard-filters/DashboardFilters';
import { isAuthorizedAction } from '../../../helpers/dashboard-helpers';
import ImportDashboardsWindow from './import-dashboards-window/ImportDashboardsWindow';

const DashboardLibraryHeaderMain = ({
    isMobileMenuShown,
    isMobileDevice,
    runningDashboardId,
    goToRunningDashboard,
    toggleSettingsModal,
    activateDashboardExportMode,
    showImportDashboardsWindow,
    toggleFilters,
    areFiltersShown,
    handleToggleMobileMenu,
    isImportDashboardsWindowVisible,
    onImportDashboardsWindowClose,
    onImportDashboards,
    isFetchingDashboards
}) => {
    return (
        <>
            <div
                className={`glu-page__header ${
                    isMobileMenuShown
                    && 'glu-page__header--no-shadow'
                } glu-flex glu-flex-row glu-flex-grow glu-flex-align-center`}
            >
                <div className="glu-flex-grow">
                    <div className="glu-page__title">Dashboard Library</div>
                </div>
                <div className="glu-flex-row">
                    {!isMobileDevice && (
                        <>
                            <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                                <IconButton
                                    isDisabled={!runningDashboardId}
                                    onClick={goToRunningDashboard(runningDashboardId)}
                                    icon="dashboard"
                                    text="Go to running dashboard"
                                />
                            </div>
                            {
                                isAuthorizedAction('privateDashboardWrite')
                                && (
                                    <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                                        <IconButton
                                            icon="dashboard-add"
                                            text="Create new dashboard"
                                            onClick={toggleSettingsModal}
                                        />
                                    </div>
                                )
                            }
                            {
                                isAuthorizedAction('privateDashboardWrite')
                                &&
                                (
                                    <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                                        <IconButton
                                            icon="import"
                                            text="Import dashboards"
                                            onClick={showImportDashboardsWindow}
                                            isDisabled={isFetchingDashboards}
                                        />
                                    </div>
                                )
                            }
                            <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                                <IconButton
                                    icon="export"
                                    text="Export dashboards"
                                    onClick={activateDashboardExportMode}
                                    isDisabled={isFetchingDashboards}
                                />
                            </div>
                            <div className="glu-flex-shrink glu-dashboard-library__filter-icon">
                                <Tooltip
                                    placement="topRight"
                                    trigger={['hover']}
                                    overlay={<span>Filter</span>}
                                >
                                    <button
                                        className="glu-btn-link"
                                        tooltip-id="dashboard-filter"
                                    >
                                        <IconButton
                                            icon="filter"
                                            onClick={toggleFilters}
                                            className={
                                                areFiltersShown
                                                    ? 'active'
                                                    : ''
                                            }
                                        />
                                    </button>
                                </Tooltip>
                            </div>
                        </>
                    )}
                    {isMobileDevice && (
                        <>
                            <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                                <IconButton
                                    onClick={handleToggleMobileMenu}
                                    icon={
                                        isMobileMenuShown
                                            ? 'close'
                                            : 'hamburger'
                                    }
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
            {isMobileDevice && isMobileMenuShown && (
                <div className="glu-page__mobile-menu">
                    <div className="mobile-menu__item">
                        <IconButton
                            isDisabled={!runningDashboardId}
                            onClick={goToRunningDashboard(
                                runningDashboardId
                            )}
                            icon="dashboard"
                            text="Go to running dashboard"
                        />
                    </div>
                    <div className="mobile-menu__item">
                        <IconButton
                            icon="filter"
                            onClick={toggleFilters}
                            className={
                                areFiltersShown ? 'active' : ''
                            }
                            text="Filter"
                        />
                    </div>
                </div>
            )}
            {areFiltersShown && (
                <DashboardFilters
                    isMobileDevice={isMobileDevice}
                    closeFilters={toggleFilters}
                />
            )}

            {isImportDashboardsWindowVisible && (
                    <ImportDashboardsWindow
                        visible={isImportDashboardsWindowVisible}
                        onClose={onImportDashboardsWindowClose}
                        onImportDashboards={onImportDashboards}
                    />
                )}

        </>
    );
};

DashboardLibraryHeaderMain.propTypes = {
    isMobileMenuShown: PropTypes.bool.isRequired,
    isMobileDevice: PropTypes.bool.isRequired,
    runningDashboardId: PropTypes.string,
    goToRunningDashboard: PropTypes.func.isRequired,
    toggleSettingsModal: PropTypes.func.isRequired,
    activateDashboardExportMode: PropTypes.func.isRequired,
    showImportDashboardsWindow: PropTypes.func.isRequired,
    onImportDashboardsWindowClose: PropTypes.func.isRequired,
    toggleFilters: PropTypes.func.isRequired,
    areFiltersShown: PropTypes.bool.isRequired,
    handleToggleMobileMenu: PropTypes.func.isRequired,
    onImportDashboards: PropTypes.func.isRequired,
    isFetchingDashboards: PropTypes.bool.isRequired
};

DashboardLibraryHeaderMain.deafultProps = {
    runningDashboardId: null
};

export default DashboardLibraryHeaderMain;
